export default {
  '-120': '(UTC +2) Калининград',
  '-180': '(UTC +3) Москва, Санкт-Петербург',
};
